export default "__VITE_PUBLIC_ASSET__28e5721c__"